/** 全民股东 · 管理端本地常量（无字典表时使用） */

export const SHAREHOLDER_USER_STATUS = [
  { value: 0, label: '待审核', type: 'warning' },
  { value: 1, label: '正常', type: 'success' },
  { value: 2, label: '已拒绝', type: 'info' },
  { value: 3, label: '禁用', type: 'danger' },
  { value: 4, label: '黑名单', type: 'danger' }
]

export const SHAREHOLDER_BECOME_TYPE = [
  { value: 0, label: '后台指定' },
  { value: 1, label: '申请成为' },
  { value: 2, label: '消费次数' },
  { value: 3, label: '消费金额' },
  { value: 4, label: '购买指定商品' }
]

export const SHAREHOLDER_BECOME_ORDER = [
  { value: 0, label: '付款后' },
  { value: 1, label: '完成后' }
]

export const SHAREHOLDER_LEVEL_TYPE = [
  { value: 0, label: '分销订单总额(已结算佣金)' },
  { value: 1, label: '一级分销订单金额(已结算佣金)' },
  { value: 2, label: '分销订单总数(已结算佣金笔数)' },
  { value: 3, label: '一级分销订单总数(已结算佣金笔数)' },
  { value: 4, label: '自购订单金额(完成单)' },
  { value: 5, label: '自购订单数量(完成单)' },
  { value: 6, label: '下线总人数' },
  { value: 7, label: '一级下线人数' },
  { value: 8, label: '下级分销商总人数' },
  { value: 9, label: '一级分销商人数' },
  { value: 10, label: '已提现佣金总金额' },
  { value: 11, label: '已发放分红总金额' }
]

export const SHAREHOLDER_SETTLE_STATUS = [
  { value: 0, label: '待确认', type: 'warning' },
  { value: 1, label: '待结算', type: '' },
  { value: 2, label: '已结算', type: 'success' },
  { value: -1, label: '已作废', type: 'info' }
]

/** C 端可配置文案：key 写入 textsJson，value 为展示文案（对齐微宝典 globonus） */
export const DEFAULT_TEXTS: Record<string, string> = {
  partner: '股东',
  center: '股东中心',
  become: '成为股东',
  bonus: '分红',
  bonus_total: '累计分红',
  bonus_lock: '待结算分红',
  bonus_wait: '预计分红',
  bonus_pay: '已结算分红',
  bonus_detail: '分红明细',
  bonus_charge: '扣除提现手续费'
}

/** 管理端「文案」Tab 左侧中文说明（勿把英文 key 直接当 label） */
export const TEXT_FIELD_LABELS: Record<string, string> = {
  partner: '身份称呼',
  center: '中心页标题',
  become: '成为/申请按钮',
  bonus: '分红统称',
  bonus_total: '累计分红',
  bonus_lock: '待结算分红',
  bonus_wait: '预计分红',
  bonus_pay: '已结算分红',
  bonus_detail: '分红明细入口',
  bonus_charge: '提现手续费说明'
}

export function labelOf(
  options: { value: number; label: string }[],
  value: number | null | undefined
) {
  return options.find((o) => o.value === value)?.label ?? String(value ?? '')
}

export function tagTypeOf(
  options: { value: number; label: string; type?: string }[],
  value: number | null | undefined
) {
  return (options.find((o) => o.value === value)?.type as any) || 'info'
}
